import { Trans, useTranslation } from "react-i18next"
import { enumStatutFormation } from "../../enums/enumStatutFormation";
import FormationHelper from "../../utils/formationHelper"
import { DisplayImage } from "../image/displayImage";
import Helper from '../../utils/helper';
import "./formationListItem.css"
import { useEffect } from "react";


export const FormationListItem = (props) => {

    const { t } = useTranslation();

    // safe access to first composante
    const composante = props?.formation?.composanteEcole?.[0];

    const checkFormation = () => {
        const formationId = props?.formation?.id;
        if (!formationId) return;

        const composanteNom = composante?.nom || "";
        const path = FormationHelper.buildFormationPath(composanteNom, FormationHelper.nomCompletFormaterUrl(props.formation || {}));
        const win = window.open("/course/" + formationId + path);
        if (win && typeof win.focus === 'function') win.focus();
    }


    return (
        <div className={props.vertical ? ("formation-list-item-main-container-vertical") : ("formation-list-item-main-container")} onClick={checkFormation}>
            <div>
                {(composante?.logoId || composante?.ecole?.logoId) && (
                    <DisplayImage imageId={composante?.logoId ?? composante?.ecole?.logoId} />
                )}
            </div>
            <div className="formation-list-item-info">
                <div className="formation-list-item-composante">
                    <span>{composante?.nom}</span>
                </div>
                <div>
                    <span>{FormationHelper.nomCompletFormater(props.formation, t('formation.parcours_separator'))}</span>
                </div>
                <div className="formation-list-item-obtention">
                    {props.statut == enumStatutFormation.AVENIR && <span className="formation-list-item-a-venir"><Trans i18nKey='profile.formation_not_started'/></span>}
                    {props.statut == enumStatutFormation.ENCOURS && <Trans i18nKey='profile.formationInProgress'/>}
                    {props.statut == enumStatutFormation.SUIVIE && <Trans i18nKey='profile.diploma_passed_in' values={{year:props.anneeDiplome}}/>}
              </div>
            </div>
        </div>
    )
}